/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Captcha_RequiredInputs */

const cs_public_site_captcha_required = /** @type {(inputs: Public_Site_Captcha_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosím dokončete captcha ověření.`)
};

const en_public_site_captcha_required = /** @type {(inputs: Public_Site_Captcha_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please complete the captcha.`)
};

/**
* | output |
* | --- |
* | "Please complete the captcha." |
*
* @param {Public_Site_Captcha_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_captcha_required = /** @type {((inputs?: Public_Site_Captcha_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Captcha_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_captcha_required(inputs)
	return cs_public_site_captcha_required(inputs)
});